/* Grid images Slider section
--------------------------------------*/

// import Swiper from "../vendors/swiper";

class FeaturedSlider {
  constructor (parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.reviews-section .reviews-slider-js');
    if(!sliders){
      return;
    }
    if (window.innerWidth > 767) {
      let noOfBlocks = qs(".block-length-js").value;
      if(noOfBlocks <= 3) {
        return false;
      }
    }
    sliders.forEach(element => {
      let featuredSliderSectionId = element.dataset.id;
      let featuredSliderSlide = element.dataset.slide;
      let featuredSliderClass = `.reviews-slider.${featuredSliderSectionId}`;
      this.FeaturedSlider(featuredSliderClass,featuredSliderSlide);

    });
  }
  FeaturedSlider = (sliderClass,featuredSliderSlide) => {
    const recommendationSlider = new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 3,
      slidesPerGroup: 1,
      shortSwipes: true,
      shortSwipesRatio: 0,
      speed: 1000,
      resistanceRatio:0.4,
      spaceBetween: 20,
      centeredSlides: true,
      centeredSlidesBounds:true,
      breakpoints: {
        1: {
          slidesPerView: 1.35,
          spaceBetween: 20,
          loop: false,
          resizeReInit: true,
          pagination:false,
          navigation:false,
          centeredSlidesBounds:false,
          initialSlide:1
        },
        768: {
          slidesPerView: 1.9,
          resizeReInit: true,
          spaceBetween: 20,
          pagination:false,
          navigation:false,
          centeredSlidesBounds:false,
          initialSlide:1
        },
        1024: {
          slidesPerView: 3,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: `${sliderClass} ~ .swiper-button-next.featured-arrow`,
        prevEl: `${sliderClass} ~ .swiper-button-prev.featured-arrow`,
      },
      // Pagination dots
      pagination: {
        el: `${sliderClass} ~ .swiper-pagination.featured-pagination`,
        type: 'bullets',
        clickable : true
      },
    });
  }

}

new FeaturedSlider(qs('.reviews-slider-js'));
